import { createFileRoute } from '@tanstack/react-router'
import { ManageSetupPage } from '@/features/manage/ManageSetupPage'

export const Route = createFileRoute('/_app/manage/setup')({
  component: ManageSetupPage,
})
